import { useParams, useNavigate } from 'react-router-dom'

export default function UnitEdit() {
  const { unitId } = useParams()
  const navigate = useNavigate()
  
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold">Edit Unit {unitId}</h1>
      <button onClick={() => navigate('/units')} className="mt-4 px-4 py-2 bg-blue-600 text-white rounded">
        Back to Units
      </button>
    </div>
  )
}
